/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getSelectedRange;
var _getSelectionStart = _interopRequireDefault(require("./get-selection-start"));
var _getSelectionEnd = _interopRequireDefault(require("./get-selection-end"));
function getSelectedRange(dom) {
  var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _api$getSelectionEnd = api.getSelectionEnd,
    getSelectionEnd = _api$getSelectionEnd === void 0 ? _getSelectionEnd.default : _api$getSelectionEnd,
    _api$getSelectionStar = api.getSelectionStart,
    getSelectionStart = _api$getSelectionStar === void 0 ? _getSelectionStart.default : _api$getSelectionStar;
  return {
    start: getSelectionStart(dom),
    end: getSelectionEnd(dom)
  };
}